import React, { useEffect, useState, useMemo } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getCartProductsWebuser } from "../../../redux/reduxApi/website/CartProductCount";
import { SquarePen, Trash2, Ruler } from "lucide-react";
import {
  clearCartApi,
  deleteCartItemThunk,
  updateCartApi,
} from "../../../redux/api/website/Addtocartapi";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import Shoploader from "../loader/Shoploader";
import Button from "../../../ui/Button";
import { motion } from "framer-motion";
import { FaCartPlus } from "react-icons/fa";
import { LiaOpencart } from "react-icons/lia";
import { useDisclosure } from "@chakra-ui/react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalCloseButton,
} from "@chakra-ui/react";
import { getShadeDetailById } from "../../../redux/api/admin/shadeApi";
import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
import {
  getContactByEmail,
  getLeadByEmail,
  convertLeadToClient,
} from "../../../redux/api/website/CheckoutApi";
import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi";
import { getMotorsList } from "../../../redux/reduxApi/admin/MotorizationReduxApi";
import { getColoursList } from "../../../redux/reduxApi/admin/ColourReduxApi";
import Heading from "../utils/Heading";

const Cart = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const userId = localStorage.getItem("UserRowId");
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [editingProduct, setEditingProduct] = useState(null);
  const [shadeData, setShadeData] = useState({});

  console.log("Selected Item:", shadeData);
  const [selectedItem, setSelectedItem] = useState(null);
  const [unit, setUnit] = useState("cm");
  const [height, setHeight] = useState("");
  const [width, setWidth] = useState("");
  const [widthWarning, setWidthWarning] = useState("");
  const [area, setArea] = useState(0);
  const [motorization, setMotorization] = useState("No");
  const [sideOfControl, setSideOfControl] = useState("Right");
  const [mechanismColor, setMechanismColor] = useState("white");
  const [remarks, setRemarks] = useState("");
  const [motorType, setMotorType] = useState("");
  const [quantity, setQuantity] = useState(1);
  const [totalLoading, setTotalLoading] = useState(false);
  const [priceBreakdown, setPriceBreakdown] = useState({
    subtotal: 0,
    taxAmount: 0,
    total: 0,
  });
  const [finalPrice, setFinalPrice] = useState(0);
  const [isUpdating, setIsUpdating] = useState(false);

  // Data states
  const [motorData, setMotorData] = useState([]);
  console.log("motorData", motorData);
  console.log("motorDatassss", motorData);
  const [colours, setColours] = useState([]);
  const [shadesData, setShadesData] = useState([]);
  const [loading, setLoading] = useState(false);

  const cart = useSelector((state) => {
    if (state.CartProducts?.data && Array.isArray(state.CartProducts.data)) {
      return state.CartProducts.data;
    }
    return [];
  });

  console.log("cart", cart);
  const [quantities, setQuantities] = useState({});
  const getInventory = useSelector((state) => state?.inventory?.inventory);

  // Fetch motors - exactly like ProductDetailPage
  useEffect(() => {
    dispatch(getMotorsList())
      .then((res) => {
        const list = res?.payload?.data?.motors || [];
        setMotorData(list);
      })
      .catch((err) => {
        console.error("Error fetching motors:", err);
        toast.error("Failed to fetch motors");
      });
  }, [dispatch]);

  // Fetch colours - exactly like ProductDetailPage
  useEffect(() => {
    const fetchColours = async () => {
      try {
        const response = await dispatch(getColoursList());
        const colours = response?.payload?.data?.colours || [];
        setColours(colours);
      } catch (error) {
        console.error("Error fetching colours:", error);
      }
    };
    fetchColours();
  }, [dispatch]);

  // Fetch shades data
  useEffect(() => {
    dispatch(getShadeNumberList())
      .then((response) => {
        const data = response.payload?.data?.shades || [];
        setShadesData(data);
      })
      .catch((error) => {
        console.error("Error fetching Shades data:", error);
      });
  }, [dispatch]);

  // Fetch products
  useEffect(() => {
    dispatch(getProduct({ page: 1, limit: 300 }));
  }, [dispatch]);

  // Fetch cart
  useEffect(() => {
    const fetchUserCart = async () => {
      try {
        setLoading(true);
        if (userId) {
          await dispatch(getCartProductsWebuser());
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error("Error fetching cart:", error);
      }
    };
    fetchUserCart();
  }, [dispatch, userId]);

  // Initialize quantities
  useEffect(() => {
    const initialQuantities = {};
    cart?.forEach((product) => {
      initialQuantities[product.ROWID] = Number(product?.quantity) || 1;
    });
    setQuantities(initialQuantities);
  }, [cart]);

  // Get item name by product ID
  const getItemNameByProductId = (productId) => {
    if (!Array.isArray(getInventory)) return "N/A";
    const matched = getInventory.find((inv) => inv.ROWID === productId);
    return matched?.itemName || "N/A";
  };

  // Get motor name by ID
  const getMotorNameById = (motorRowIdOrName) => {
    if (
      !motorRowIdOrName ||
      motorRowIdOrName === "N/A" ||
      !Array.isArray(motorData) ||
      motorData.length === 0
    ) {
      return "N/A";
    }

    const motor = motorData.find(
      (m) =>
        m.ROWID === motorRowIdOrName ||
        m.motorName === motorRowIdOrName
    );

    return motor?.motorName || "N/A";
  };

  // Get shade image
  const getShadeImageByShadeNo = (shadeNo) => {
    if (!shadesData || shadesData.length === 0 || !shadeNo) {
      return "/fallback-image.jpg";
    }
    const shade = shadesData.find((item) => item.shadeNo === shadeNo);
    if (shade && shade.shadeMedia && shade.shadeMedia.length > 0) {
      return shade.shadeMedia[0];
    }
    return "/fallback-image.jpg";
  };

  // Area is calculated and stored/displayed in Square Metres (m²).
  // Business rules:
  // - Drop below 1 metre uses 1 metre.
  // - Minimum billable area is 1 m².
  const inchesToSqM = (widthInch, dropInch) => {
    if (widthInch <= 0 || dropInch <= 0) return 0;

    const effectiveDropInch = Math.max(dropInch, 39.37);
    const areaSqFt = (widthInch * effectiveDropInch) / 144;

    return Math.max(areaSqFt / 10.764, 1);
  };

  const mmToSqM = (widthMm, dropMm) => {
    if (widthMm <= 0 || dropMm <= 0) return 0;

    const effectiveDropMm = Math.max(dropMm, 1000);
    const areaSqM = widthMm * effectiveDropMm * 0.000001;

    return Math.max(areaSqM, 1);
  };

  const cmToSqM = (widthCm, dropCm) => {
    if (widthCm <= 0 || dropCm <= 0) return 0;

    const effectiveDropCm = Math.max(dropCm, 100);
    const areaSqM = widthCm * effectiveDropCm * 0.0001;

    return Math.max(areaSqM, 1);
  };

  const calculateArea = (heightValue, widthValue, unit) => {
    const h = Number(heightValue) || 0;
    const w = Number(widthValue) || 0;

    if (h <= 0 || w <= 0) return 0;

    switch (unit) {
      case "inch":
        return inchesToSqM(w, h);
      case "mm":
        return mmToSqM(w, h);
      case "cm":
        return cmToSqM(w, h);
      default:
        return 0;
    }
  };

  const calculateProductTotal = (product) => {
    const qty = quantities[product.ROWID] || product.quantity || 1;
    const price = parseFloat(product.sellingPrice || product.price) || 0;

    // If the product has area-based pricing
    if (product.area) {
      const area = parseFloat(product.area) || 0;
      return (area * qty * price).toFixed(2);
    }

    // Simple quantity * price
    return (qty * price).toFixed(2);
  };
  const calculateAmount = (area, qty, rate) => {
    const a = Number(area) || 0;
    const q = Number(qty) || 0;
    const r = Number(rate) || 0;

    // Amount = Area × Quantity × Rate
    const subtotal = a * q * r;

    return {
      subtotal: Number(subtotal.toFixed(2)),
      total: Number(subtotal.toFixed(2)), // Same as subtotal since no tax
    };
  };

  // Calculate area when dimensions change
  useEffect(() => {
    if (height && width && unit) {
      const calculatedArea = calculateArea(height, width, unit);
      setArea(calculatedArea);
    } else {
      setArea(0);
    }
  }, [height, width, unit]);

  // Calculate price breakdown
  // Calculate price breakdown when values change
  useEffect(() => {
    if (selectedItem && area > 0 && quantity > 0) {
      const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
      const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;

      const sellingPrice = itemPrice + shadePrice;
      const breakdown = calculateAmount(area, quantity, sellingPrice);
      setPriceBreakdown(breakdown);
    } else {
      setPriceBreakdown({
        subtotal: 0,
        total: 0,
      });
    }
  }, [area, quantity, selectedItem, shadeData]);

  // Calculate final price with motor
  useEffect(() => {
    // Base calculation (area × sellingPrice × quantity)
    const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
    const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;

    const rate = itemPrice + shadePrice;

    const baseTotal = area * rate * quantity;

    // Motor price calculation
    let motorTotal = 0;
    if (motorization === "Yes" && motorType) {
      const selectedMotor = motorData.find((m) => m.motorName === motorType);
      const motorPrice = parseFloat(selectedMotor?.motorPrice) || 0;
      // Motor price should also be multiplied by quantity
      motorTotal = motorPrice * quantity;
    }

    // Total = baseTotal + motorTotal
    const total = baseTotal + motorTotal;

    setFinalPrice(total);
  }, [
    area,
    selectedItem?.sellingPrice,
    shadeData?.sellingPrice,
    quantity,
    motorization,
    motorType,
    motorData,
  ]);

  const handleIncrease = () => setQuantity((prev) => prev + 1);
  const handleDecrease = () => setQuantity((prev) => (prev > 1 ? prev - 1 : 1));

  const handleItemChange = (itemId) => {
    const selected = shadeData.items?.find(
      (item) => item.ROWID === itemId
    );

    const inventoryItem = getInventory?.find(
      (inv) => inv.ROWID === selected?.ROWID
    );

    setSelectedItem({
      ...selected,
      subCategoryId: inventoryItem?.subCategoryId,
    });
  };

  const handleEditClick = async (product) => {
    setEditingProduct(product);
    try {
      setLoading(true);
      const shadeByNumber = shadesData.find(
        (shade) => shade.shadeNo === product.shadeNo,
      );

      if (shadeByNumber) {
        setShadeData(shadeByNumber);
        if (shadeByNumber.items && shadeByNumber.items.length > 0) {
          const matchingItem =
            shadeByNumber.items.find(
              (item) => item.ROWID === product.productId,
            ) || shadeByNumber.items[0];
          setSelectedItem(matchingItem);
        }
      } else {
        const itemDetails = getInventory?.find(
          (item) => item.ROWID === product.productId,
        );

        const basicShadeData = {
          shadeNo: product.shadeNo,
          maxWidth: product.maxWidth || "1000",
          items: [
            {
              ROWID: product.productId,
              itemName:
                itemDetails?.itemName ||
                getItemNameByProductId(product.productId) ||
                "Product",
              sellingPrice: product.sellingPrice || product.price || 0,
              tax: product.taxRate || 0,
              subCategory:
                itemDetails?.subCategory || product.subCategory || "",
              availableStock: product.availableStock || 0,
            },
          ],
        };
        setShadeData(basicShadeData);
        setSelectedItem(basicShadeData.items[0]);
      }
      console.log("Setting form values from product:", product);
      setUnit(product.measurements || "cm");
      setHeight(product.height || "");
      setWidth(product.width || "");
      setMotorization(product.motorization || "No");
      setSideOfControl(product.sideOfControl || "Right");
      setMechanismColor(product.mechanismColor || "white");
      setRemarks(product.remarks || "");
      let motorFound = motorData.find((m) => m.motorName === product.motorType);
      if (!motorFound) {
        motorFound = motorData.find((m) => m.ROWID === product.motorType);
      }

      if (motorFound) {
        setMotorType(motorFound.motorName);
      } else {
        setMotorType(product.motorType || "");
      }

      console.log("Motor type set to:", product.motorType);

      setQuantity(parseInt(product.quantity) || 1);

      onOpen();
    } catch (error) {
      console.error("Error in handleEditClick:", error);
      toast.error("Failed to load product details");
    } finally {
      setLoading(false);
    }
  };
  // Handle update cart
  const handleUpdateCart = async () => {
    if (!editingProduct) return;

    if (!selectedItem) {
      toast.error("Please select a product item first");
      return;
    }

    if (!height || !width) {
      toast.error("Please enter height and width");
      return;
    }

    const minWidthMM = shadeData?.minWidth || 300;
    const maxWidthMM = parseFloat(shadeData?.maxWidth || 0);

    let valueInMM = parseFloat(width);

    if (unit === "cm") valueInMM *= 10;
    if (unit === "inch") valueInMM *= 25.4;

    if (valueInMM < minWidthMM) {
      toast.error("Width is below minimum limit");
      return;
    }

    if (maxWidthMM && valueInMM > maxWidthMM) {
      toast.error("Width exceeds maximum limit");
      return;
    }

    setIsUpdating(true);

    try {
      let motorRowId = "";
      if (motorization === "Yes" && motorType) {
        const selectedMotor = motorData.find((m) => m.motorName === motorType);
        motorRowId = selectedMotor?.ROWID || "";
      }
      const calculatedArea = calculateArea(height, width, unit) || 0;
      const itemPrice = parseFloat(selectedItem?.sellingPrice) || 0;
      const shadePrice = parseFloat(shadeData?.sellingPrice) || 0;

      const finalRate = itemPrice + shadePrice;
      const updateData = {
        productId: selectedItem?.ROWID || editingProduct.productId,
        quantity: quantity.toString(),
        price: finalRate.toString(),
        customerId: userId || null,
        measurements: unit,
        status: "Active",
        total: finalPrice.toFixed(2).toString(),
        area: calculatedArea.toString(),
        height: height.toString(),
        width: width.toString(),
        motorization: motorization,
        sideOfControl: sideOfControl,
        mechanismColor: mechanismColor,
        motorType: motorRowId,
        remarks: remarks,
      };
      const response = await updateCartApi(editingProduct.ROWID, updateData);

      if (response.data.success) {
        toast.success("Cart item updated successfully");
        await dispatch(getCartProductsWebuser());
        onClose();
      } else {
        toast.error(response.data.message || "Failed to update cart item");
      }
    } catch (error) {
      console.error("Error updating cart item:", error);
      toast.error(
        error.response?.data?.message || "Failed to update cart item",
      );
    } finally {
      setIsUpdating(false);
    }
  };

  const increaseQuantity = async (product) => {
    const newQty = (quantities[product.ROWID] || product.quantity || 1) + 1;

    setTotalLoading(true);

    setQuantities((prev) => ({
      ...prev,
      [product.ROWID]: newQty,
    }));

    try {
      const height = Number(product.height) || 0;
      const width = Number(product.width) || 0;
      const unit = product.measurements || "cm";

      const area = calculateArea(height, width, unit);

      const price = Number(product.sellingPrice || product.price) || 0;

      let baseTotal = area * newQty * price;

      let motorTotal = 0;

      if (product.motorization === "Yes" && product.motorType) {
        const selectedMotor = motorData.find(
          (m) =>
            m.ROWID === product.motorType ||
            m.motorName === product.motorType
        );
        const motorPrice = parseFloat(selectedMotor?.motorPrice) || 0;
        motorTotal = motorPrice * newQty;
      }

      const total = (baseTotal + motorTotal).toFixed(2);

      const updateData = {
        productId: product.productId,
        quantity: newQty.toString(),
        price: price.toString(),
        customerId: userId,
        measurements: unit,
        area: area.toString(),
        height: height.toString(),
        width: width.toString(),
        motorization: product.motorization,
        sideOfControl: product.sideOfControl,
        mechanismColor: product.mechanismColor,
        motorType: product.motorType,
        remarks: product.remarks,
        total: total,
      };

      await updateCartApi(product.ROWID, updateData);
      await dispatch(getCartProductsWebuser());
    } catch (error) {
      console.error("Error updating quantity:", error);
      toast.error("Failed to update quantity");
    } finally {
      setTotalLoading(false);
    }
  };

  const decreaseQuantity = async (product) => {
    const currentQty = quantities[product.ROWID] || product.quantity || 1;
    const newQty = Math.max(1, currentQty - 1);

    setTotalLoading(true);

    setQuantities((prev) => ({
      ...prev,
      [product.ROWID]: newQty,
    }));

    try {
      const height = Number(product.height) || 0;
      const width = Number(product.width) || 0;
      const unit = product.measurements || "cm";

      const area = calculateArea(height, width, unit);

      const price = Number(product.sellingPrice || product.price) || 0;

      let baseTotal = area * newQty * price;

      let motorTotal = 0;

      if (product.motorization === "Yes" && product.motorType) {
        const selectedMotor = motorData.find(
          (m) =>
            m.ROWID === product.motorType ||
            m.motorName === product.motorType
        );
        const motorPrice = parseFloat(selectedMotor?.motorPrice) || 0;
        motorTotal = motorPrice * newQty;
      }

      const total = (baseTotal + motorTotal).toFixed(2);

      const updateData = {
        productId: product.productId,
        quantity: newQty.toString(),
        price: price.toString(),
        customerId: userId,
        measurements: unit,
        area: area.toString(),
        height: height.toString(),
        width: width.toString(),
        motorization: product.motorization,
        sideOfControl: product.sideOfControl,
        mechanismColor: product.mechanismColor,
        motorType: product.motorType,
        remarks: product.remarks,
        total: total,
      };

      await updateCartApi(product.ROWID, updateData);
      await dispatch(getCartProductsWebuser());

    } catch (error) {
      console.error("Error updating quantity:", error);
      toast.error("Failed to update quantity");
    } finally {
      setTotalLoading(false);
    }
  };

  const handleRemove = async (ROWID) => {
    try {
      const response = await dispatch(deleteCartItemThunk(ROWID));
      if (response.payload?.success) {
        toast.success("Item removed from cart");
        await dispatch(getCartProductsWebuser());
      } else {
        toast.error(response.payload?.message || "Failed to remove item");
      }
    } catch (error) {
      console.error("Error removing item:", error);
      toast.error("Something went wrong");
    }
  };

  const clearCart = async () => {
    try {
      if (!cart || cart.length === 0) {
        toast.info("Cart is already empty");
        return;
      }
      const rowIds = cart.map((item) => item.ROWID);
      const response = await dispatch(clearCartApi(rowIds));
      if (response.payload) {
        toast.success("Cart cleared successfully");
        await dispatch(getCartProductsWebuser());
      }
    } catch (error) {
      console.error("Error clearing cart:", error);
      toast.error("Something went wrong");
    }
  };

  const [checkoutLoading, setCheckoutLoading] = useState(false);

  const handleCheckout = async () => {
    const userId = localStorage.getItem("UserRowId");
    const userEmail = localStorage.getItem("userEmail");

    if (!userId || !userEmail) {
      localStorage.setItem("redirect", location.pathname);
      navigate("/login");
      return;
    }

    try {
      setCheckoutLoading(true);

      // Check lead by email
      const leadAction = await dispatch(getLeadByEmail(userEmail));
      const leadRes = leadAction.payload;
      console.log("Lead check result:", leadRes);
      console.log("Lead response", leadAction)

      if (leadRes?.success && leadRes?.data) {
        const leadId = leadRes.data.ROWID;
        const convertAction = await dispatch(convertLeadToClient(leadId));
        const convertRes = convertAction.payload;

        if (convertRes?.success) {
          const clientId =
            convertRes.data?.clientId || convertRes.data?.ROWID || leadId;

          navigate("/shop/checkouts", {
            state: {
              clientId: clientId,
              cartItems: cart,
              subtotal: calculateSubtotal(),
              shippingCost: calculateShipping(),
              total: calculateTotal(),
            },
          });
          return;
        }
      }

      // Check contact by email
      const contactResponse = await getContactByEmail(userEmail);
      if (contactResponse?.success && contactResponse?.rowid?.[0]?.contact) {
        const contactId = contactResponse?.rowid?.[0]?.contact?.ROWID;
        navigate("/shop/checkouts", {
          state: {
            clientId: contactId,
            cartItems: cart,
            subtotal: calculateSubtotal(),
            shippingCost: calculateShipping(),
            total: calculateTotal(),
          },
        });
        return;
      }

      toast.error("No user found with this email. Please register first.");
    } catch (err) {
      console.error("Checkout error:", err);
      toast.error("Checkout failed. Please try again.");
    } finally {
      setCheckoutLoading(false);
    }
  };

  const calculateSubtotal = () => {
    if (!cart || cart.length === 0) return "0.00";

    return cart
      .reduce((acc, product) => {
        // Use the total field from each cart item
        const itemTotal = parseFloat(product.total) || 0;
        return acc + itemTotal;
      }, 0)
      .toFixed(2);
  };

  const calculateShipping = () => {
    return (parseFloat(calculateSubtotal()) * 0.18).toFixed(2);
  };

  const calculateTotal = () => {
    return (
      parseFloat(calculateSubtotal()) + parseFloat(calculateShipping())
    ).toFixed(2);
  };

  const subtotal = calculateSubtotal();
  const shippingCost = calculateShipping();
  const total = Math.round(parseFloat(calculateSubtotal()));

  return (
    <div className="container mx-auto sm:!py-4 md:py-8">
      {loading ? (
        <div className="relative w-full h-[300px]">
          <Shoploader />
        </div>
      ) : cart?.length === 0 ? (
        /* Empty Cart State */
        <div className="w-full mx-auto text-center py-16 px-4">
          <div className="max-w-md mx-auto">
            <motion.div
              animate={{ y: [0, -20, 0], rotate: [0, 5, -5, 0] }}
              transition={{
                duration: 4,
                repeat: Infinity,
                repeatType: "reverse",
              }}
            >
              <LiaOpencart className="text-8xl text-[#66944b] mx-auto" />
            </motion.div>
            <h2 className="text-3xl font-semibold text-[#661E33] mb-3">
              Your Cart is Empty
            </h2>
            <p className="text-gray-500 text-base mb-8">
              Looks like you haven't added anything yet. Explore our collection
              and find something special!
            </p>
            <Link to="/shop">
              <button className="px-6 py-3 bg-[#66944b] hover:bg-[#5a8240] text-white rounded-lg font-medium transition-colors">
                Continue Shopping
              </button>
            </Link>
          </div>
        </div>
      ) : (
        <>

         <div className="flex flex-col items-center text-center !mt-2 md:!mt-0 lg:!mt-0 mb-3">
                <Heading text={"Your Custom Order"} className="mt-2 md:!mt-0" />
                <hr className="heading-seperator border-t-4 border-[#66944b] opacity-100 w-24 mx-auto" />
                {/* <p className="text-gray-600 mt-2">
                  Review your customized selections before checkout.
                </p> */}
              </div>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">

            
            {/* Cart Items */}
            <div className="lg:col-span-9">
             

              <div className="border rounded-lg overflow-hidden">
                {/* Header */}
                <div className="hidden md:grid grid-cols-12 gap-4 p-3 bg-gradient-to-r from-[#66944b] to-[#7fb073] text-sm font-semibold text-white">
                  <div className="col-span-8">Product Details</div>
                  <div className="col-span-2 text-center">Unit Price</div>
                  <div className="col-span-2 text-center">Total</div>
                </div>

                {/* Cart Items List */}
                <div className="divide-y">
                  {cart.map((product) => {
                    const imageUrl = getShadeImageByShadeNo(product?.shadeNo);

                    return (
                      <div key={product.ROWID} className="p-1 py-2 md:py-0 md:!p-4  hover:bg-gray-50">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-0 md:!gap-4 lg:!gap-4">
                          {/* Product Info */}
                          <div className="md:col-span-8 flex gap-2  md:gap-4">
                            <div className="w-24 h-24 rounded-lg overflow-hidden bg-gray-100 border flex-shrink-0">
                              <img
                                src={imageUrl}
                                alt={product.shadeNo}
                                className="w-full h-full object-cover"
                              // onError={(e) =>
                              //   (e.target.src = "/fallback-image.jpg")
                              // }
                              />
                            </div>

                            <div className="flex-1">
                              <p className="font-semibold text-gray-800 mb-0">
                                Shade {product.shadeNo}
                              </p>
                              <div className="text-sm text-gray-600 space-y-1 mt-2">
                                <p className="mb-0">
                                  Dimensions: {product.width}{" "}
                                  {product.measurements} x {product.height}{" "}
                                  {product.measurements}
                                </p>
                                <p>
                                  Mechanism:{" "}
                                  {getItemNameByProductId(product.productId)}
                                </p>
                                <p>Color: {product.mechanismColor || "N/A"}</p>
                                {product?.motorization === "Yes" && (
                                <p>
                                  Motor:{" "}
                                  {product.motorization === "Yes"
                                    ? getMotorNameById(product.motorType)
                                    : "No"}
                                </p>
                                )}
                                {product.remarks && (
                                  <p className="italic">
                                    Note: {product.remarks}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>

                          {/* Price and Actions */}
                          <div className="md:col-span-4 flex flex-col items-end justify-between">
                            <div className="w-full flex justify-between md:justify-center lg:justify-around md:items-end gap-2">
                              <span className="text-gray-600 font-bold">
                                ₹
                                {parseFloat(
                                  product.sellingPrice || product.price,
                                ).toFixed(2)} Per sq m
                              </span>
                              {/* <span className="font-bold text-[#66944b] text-lg">
                                ₹{product.total || "0"}
                              </span> */}
                              <span className="font-bold text-[#66944b]">
                                {totalLoading ? (
                                  <div className="w-5 h-5 border-2 border-[#66944b] border-t-transparent rounded-full animate-spin"></div>
                                ) : (
                                  `₹${product.total || "0"}`
                                )}
                              </span>
                            </div>

                            <div className="flex items-center gap-1 w-full justify-between md:justify-center ">
                              {/* Quantity Controls */}
                              <div className="flex items-center border rounded-lg">
                                <button
                                  onClick={() =>
                                    decreaseQuantity(product)
                                  }
                                  className="px-3 py-1 bg-gray-200 hover:bg-gray-100 font-bold"
                                >
                                  -
                                </button>
                                <span className="w-12 text-center">
                                  {quantities[product.ROWID]}
                                </span>
                                <button
                                  onClick={() =>
                                    increaseQuantity(product)
                                  }
                                  className="px-3 py-1 bg-gray-200 hover:bg-gray-100"
                                >
                                  +
                                </button>
                              </div>

                              {/* Action Buttons */}
                              <div className="flex items-center justify-center">
                              <button
                                onClick={() => handleEditClick(product)}
                                className="p-2 text-blue-600 hover:bg-blue-50 rounded"
                                title="Edit"
                              >
                                <SquarePen size={18} />
                              </button>
                              <button
                                onClick={() => handleRemove(product.ROWID)}
                                className="p-2 text-red-500 hover:bg-red-50 rounded"
                                title="Remove"
                              >
                                <Trash2 size={18} />
                              </button>
                              </div> 
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>

              {cart.length > 0 && (
                <div className="mt-4">
                  <Button text="Clear Cart" onClick={clearCart} />
                </div>
              )}
            </div>

            {/* Order Summary */}
            <div className="lg:col-span-3">
              <div className="border rounded-lg p-4 sticky top-4">
                <h2 className="text-xl font-bold text-center pb-2 border-b">
                  Order Summary
                </h2>
                <div className="space-y-2 mt-4">
                  <div className="flex justify-between">
                    <span>Subtotal:</span>
                    {/* <span className="font-bold">₹{subtotal}</span> */}
                    <span className="font-bold text-[#66944b]">
                      {totalLoading ? (
                        <div className="w-5 h-5 border-2 border-[#66944b] border-t-transparent rounded-full animate-spin"></div>
                      ) : (
                        `₹${subtotal}`
                      )}
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span>Shipping:</span>
                    <span className="font-bold">₹ 0.00</span>
                    {/* <span className="font-bold">₹{shippingCost}</span> */}
                  </div>
                  <p className="font-semibold mb-0">Shipping Charges will calculate after address selection</p>

                  <div className="flex justify-between pt-2 border-t">
                    <span className="font-bold">Total:</span>
                    <span className="font-bold text-[#66944b]">
                      {/* ₹{subtotal} */}
                    </span>
                    {/* <span className="font-bold text-[#66944b]">₹{total}</span> */}
                    <span className="font-bold text-[#66944b]">
                      {totalLoading ? (
                        <div className="w-5 h-5 border-2 border-[#66944b] border-t-transparent rounded-full animate-spin"></div>
                      ) : (
                        `₹${total}`
                      )}
                    </span>
                  </div>
                </div>

                <button
                  onClick={handleCheckout}
                  disabled={checkoutLoading}
                  className="w-full bg-[#661e33] text-white py-2 rounded-lg mt-4 hover:bg-[#4a1626] transition-colors disabled:opacity-50"
                >
                  {checkoutLoading ? "Processing..." : "Proceed to Checkout"}
                </button>

                <Link to="/shop">
                  <button className="w-full border border-[#661e33] text-[#661e33] py-2 rounded-lg mt-2 hover:bg-gray-50 transition-colors">
                    Continue Shopping
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Edit Modal - Exactly matching ProductDetailPage styling */}
      <Modal isOpen={isOpen} onClose={onClose} size="3xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="xl" maxH="95vh" overflowY="auto">
          <ModalHeader p={0}>
            <div className="bg-gradient-to-r from-[#66944b] to-[#7fb073] py-3 px-4 rounded-t-xl">
              <h2 className="text-2xl font-bold text-white">
                Edit Customization
              </h2>
              <p className="text-white/80 text-sm">
                Modify your custom blinds configuration
              </p>
            </div>
          </ModalHeader>
          <ModalCloseButton className="text-white" />

          <ModalBody>
            <div className="!p-0 md:!p-4 space-y-4">
              <div className="space-y-3">
                <div className="flex items-center justify-between bg-white p-3 rounded-lg border">
                  <span className="text-sm font-medium text-gray-600">
                    Shade Number
                  </span>
                  <span className="text-sm font-bold text-[#66944b] bg-[#66944b]/10 px-3 py-1 rounded-full">
                    {shadeData?.shadeNo || editingProduct?.shadeNo || "N/A"}
                  </span>
                </div>
                {shadeData.items && shadeData.items.length > 0 && (
                  <div>
                    <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
                      <span className="text-[#66944b]">•</span> Select Mechanism
                      Type
                    </label>
                    <select
                      value={selectedItem?.ROWID || ""}
                      onChange={(e) => handleItemChange(e.target.value)}
                      className="w-full border rounded-lg px-3 py-2 text-sm focus:ring-1 focus:ring-[#66944b] focus:border-transparent"
                    >
                      {shadeData.items
                        .filter((item) => item.itemName && item.ROWID)
                        .map((item) => (
                          <option key={item.ROWID} value={item.ROWID}>
                            {item.itemName}
                          </option>
                        ))}
                    </select>
                  </div>
                )}
              </div>
              <div className="space-y-3">
                {/* Unit Selection */}
                <div className="flex items-center justify-between bg-white p-3 rounded-lg border">
                  <div className="flex items-center gap-2">
                    <Ruler className="text-[#66944b]" size={18} />
                    <span className="text-sm font-medium">Unit:</span>
                  </div>
                  <div className="flex gap-1 bg-gray-100 p-1 rounded-lg">
                    {["mm", "cm", "inch"].map((option) => (
                      <label key={option} className="cursor-pointer">
                        <input
                          type="radio"
                          name="unit"
                          value={option}
                          checked={unit === option}
                          onChange={(e) => setUnit(e.target.value)}
                          className="peer sr-only"
                        />
                        <span className="px-3 py-1 rounded-md text-xs font-medium text-gray-600 peer-checked:bg-[#66944b] peer-checked:text-white transition-all">
                          {option}
                        </span>
                      </label>
                    ))}
                  </div>
                </div>

                {/* Width & Height */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
                      <span>↔️</span> Width
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={width}
                        onChange={(e) => {
                          const newValue = e.target.value;

                          const maxWidthMM = shadeData?.maxWidth
                            ? parseFloat(shadeData.maxWidth)
                            : null;

                          const minWidthMM = shadeData?.minWidth
                            ? parseFloat(shadeData.minWidth)
                            : 300; // fallback (you can change)

                          if (newValue) {
                            let valueInMM = parseFloat(newValue);

                            switch (unit) {
                              case "cm":
                                valueInMM *= 10;
                                break;
                              case "inch":
                                valueInMM *= 25.4;
                                break;
                              case "mm":
                              default:
                                valueInMM = parseFloat(newValue);
                            }

                            if (valueInMM < minWidthMM) {
                              let minInUnit = minWidthMM;

                              switch (unit) {
                                case "cm":
                                  minInUnit = (minWidthMM / 10).toFixed(1);
                                  break;
                                case "inch":
                                  minInUnit = (minWidthMM / 25.4).toFixed(2);
                                  break;
                              }

                              setWidth(minInUnit.toString());
                              setWidthWarning(`Minimum width is ${minInUnit} ${unit}`);
                              setTimeout(() => setWidthWarning(""), 3000);
                              return;
                            }

                            if (maxWidthMM && valueInMM > maxWidthMM) {
                              let maxInUnit = maxWidthMM;

                              switch (unit) {
                                case "cm":
                                  maxInUnit = (maxWidthMM / 10).toFixed(1);
                                  break;
                                case "inch":
                                  maxInUnit = (maxWidthMM / 25.4).toFixed(2);
                                  break;
                              }

                              setWidth(maxInUnit.toString());
                              setWidthWarning(`Maximum width is ${maxInUnit} ${unit}`);
                              setTimeout(() => setWidthWarning(""), 3000);
                              return;
                            }

                            setWidth(newValue);
                            setWidthWarning("");
                          } else {
                            setWidth(newValue);
                            setWidthWarning("");
                          }
                        }}
                        className={`w-full border ${widthWarning ? "border-red-300" : "border-gray-300"} rounded-lg pl-3 pr-12 py-2 text-sm`}
                        placeholder="0.00"
                        min="0"
                        step={unit === "inch" ? "0.01" : "1"}
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-500">
                        {unit}
                      </span>
                    </div>
                    {/* {widthWarning && (
                      <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                        <span>⚠️</span> {widthWarning}
                      </p>
                    )} */}
                    {shadeData?.maxWidth && (
                      <div className="text-xs text-gray-500 mt-1 flex justify-between">
                        <span>
                          Min:{" "}
                          {unit === "mm"
                            ? `${shadeData.minWidth || 300} mm`
                            : unit === "cm"
                              ? `${((shadeData.minWidth || 300) / 10).toFixed(1)} cm`
                              : `${((shadeData.minWidth || 300) / 25.4).toFixed(2)} inch`}
                        </span>

                        <span>
                          Max:{" "}
                          {unit === "mm"
                            ? `${shadeData.maxWidth} mm`
                            : unit === "cm"
                              ? `${(shadeData.maxWidth / 10).toFixed(1)} cm`
                              : `${(shadeData.maxWidth / 25.4).toFixed(2)} inch`}
                        </span>
                      </div>
                    )}

                    {width && (
                      <div className="text-xs mt-1">
                        {(() => {
                          let valueInMM = parseFloat(width);

                          if (unit === "cm") valueInMM *= 10;
                          if (unit === "inch") valueInMM *= 25.4;

                          const min = shadeData?.minWidth || 300;
                          const max = parseFloat(shadeData?.maxWidth || 0);

                          if (valueInMM < min) {
                            return <span className="text-red-500">Below minimum</span>;
                          }

                          if (max && valueInMM > max) {
                            return <span className="text-red-500">Exceeds limit</span>;
                          }

                          return <span className="text-green-500">Within limit</span>;
                        })()}
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-700 flex items-center gap-1 mb-1">
                      <span>↕️</span> Height
                    </label>
                    <div className="relative">
                      <input
                        type="number"
                        value={height}
                        onChange={(e) => setHeight(e.target.value)}
                        className="w-full border border-gray-300 rounded-lg pl-3 pr-12 py-2 text-sm"
                        placeholder="0.00"
                        min="0"
                        step={unit === "inch" ? "0.01" : "1"}
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-gray-500">
                        {unit}
                      </span>
                    </div>
                  </div>
                </div>

                {/* Area Display */}
                {area > 0 && (
                  <div className="text-right">
                    <span className="text-sm text-gray-600">Area: </span>
                    <span className="text-sm font-bold text-[#66944b]">
                      {area.toFixed(2)} sq m
                    </span>
                  </div>
                )}
              </div>

              {/* Style & Controls */}
              <div className="space-y-3">
                {/* Motorization */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Motorization
                    </label>
                    <div className="flex gap-2 bg-white p-1 rounded-lg border w-fit">
                      {["No", "Yes"].map((option) => (
                        <label key={option} className="cursor-pointer">
                          <input
                            type="radio"
                            name="motorization"
                            value={option}
                            checked={motorization === option}
                            onChange={(e) => setMotorization(e.target.value)}
                            className="peer sr-only"
                          />
                          <span
                            className={`px-4 py-1 rounded-md text-sm font-medium transition-all ${motorization === option
                              ? "bg-[#66944b] text-white"
                              : "text-gray-600 hover:bg-gray-100"
                              }`}
                          >
                            {option}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  {/* Motor Type */}
                  {motorization === "Yes" && (
                    <div>
                      <label className="text-sm font-medium text-gray-700 block mb-1">
                        Motor Type
                      </label>
                      <select
                        value={motorType}
                        onChange={(e) => setMotorType(e.target.value)}
                        className="w-full border rounded-lg px-3 py-2 text-sm"
                      >
                        {motorData
                          .filter((motor) => {
                            const motorSubCategories = JSON.parse(
                              motor.subCategory || "[]"
                            );
                            return (
                              selectedItem &&
                              motorSubCategories.includes(selectedItem.subCategory)
                            );
                          })
                          .map((motor) => (
                            <option key={motor.ROWID} value={motor.motorName}>
                              {motor.motorName} {motor.motorPrice}
                            </option>
                          ))}
                      </select>
                    </div>
                  )}
                </div>

                {/* Side of Control & Color */}
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Side of Control
                    </label>
                    <div className="flex gap-2 bg-white p-1 rounded-lg border w-fit">
                      {["Left", "Right"].map((option) => (
                        <label key={option} className="cursor-pointer">
                          <input
                            type="radio"
                            name="sideOfControl"
                            value={option}
                            checked={sideOfControl === option}
                            onChange={(e) => setSideOfControl(e.target.value)}
                            className="peer sr-only"
                          />
                          <span
                            className={`px-4 py-1 rounded-md text-sm font-medium transition-all ${sideOfControl === option
                              ? "bg-[#66944b] text-white"
                              : "text-gray-600 hover:bg-gray-100"
                              }`}
                          >
                            {option}
                          </span>
                        </label>
                      ))}
                    </div>
                  </div>

                  <div>
                    <label className="text-sm font-medium text-gray-700 block mb-1">
                      Mechanism Colour
                    </label>
                    <select
                      value={mechanismColor}
                      onChange={(e) => setMechanismColor(e.target.value)}
                      className="w-full border rounded-lg px-3 py-2 text-sm"
                    >
                      <option value="white">White</option>
                      {colours.map((item) => (
                        <option key={item.ROWID} value={item.colour}>
                          {item.colour}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Remarks */}
                <div>
                  <label className="text-sm font-medium text-gray-700 block mb-1">
                    Remarks
                  </label>
                  <textarea
                    value={remarks}
                    onChange={(e) => setRemarks(e.target.value)}
                    className="w-full border rounded-lg px-3 py-2 text-sm resize-none"
                    placeholder="Special requests..."
                    rows={2}
                  />
                </div>
              </div>

              {/* Quantity & Price */}
              <div className="space-y-3">
                {/* Quantity */}
                <div className="flex items-center justify-between p-3 border rounded-lg">
                  <span className="text-sm font-medium">Quantity</span>
                  <div className="flex items-center border rounded-lg">
                    <button
                      onClick={handleDecrease}
                      className="px-3 py-1 hover:bg-gray-100"
                    >
                      -
                    </button>
                    <span className="w-12 text-center">{quantity}</span>
                    <button
                      onClick={handleIncrease}
                      className="px-3 py-1 hover:bg-gray-100"
                    >
                      +
                    </button>
                  </div>
                </div>

                {/* Total Price */}
                <div className="flex items-center justify-between bg-[#66944b]/5 p-3 rounded-lg border border-[#66944b]/20">
                  <span className="font-semibold">Total</span>
                  <span className="text-xl font-bold text-[#66944b]">
                    ₹{finalPrice.toFixed(2)}
                  </span>
                </div>

                {/* Error Message */}
                {(!height || !width) && selectedItem && (
                  <p className="text-sm text-red-500 flex items-center gap-1">
                    <span>⚠️</span> Please enter height & width
                  </p>
                )}
              </div>
            </div>
          </ModalBody>

          <ModalFooter className="gap-3">
            <button
              onClick={onClose}
              className="px-6 py-2 border rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={handleUpdateCart}
              disabled={isUpdating || !selectedItem || !height || !width}
              className={`px-6 py-2 rounded-lg text-white font-semibold transition-colors ${isUpdating || !selectedItem || !height || !width
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-[#66944b] hover:bg-[#5a8240]"
                }`}
            >
              {isUpdating ? "Updating..." : "Update Cart"}
            </button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </div>
  );
};

export default Cart;

// import React, { useEffect, useState, useMemo } from "react";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   cartProductCount,
//   getCartProducts,
//   getCartProductsWebuser,
// } from "../../../redux/reduxApi/website/CartProductCount";
// import { SquarePen, Trash2 } from "lucide-react";
// import {
//   clearCartApi,
//   deleteCartItemThunk,
//   deleteFromCartApi,
//   getInventoryById,
//   getProductCart,
//   updateCartProductApi,
// } from "../../../redux/api/website/Addtocartapi";
// import { AddToCart } from "./utilsfuncart";
// import {
//   decrementGuestCartCount,
//   resetGuestCartCount,
// } from "../../../redux/reduxSlice/website/CartSlice";
// import Cookies from "js-cookie";
// import { toast } from "react-toastify";
// import Shoploader from "../loader/Shoploader";
// import Button from "../../../ui/Button";
// import { MdShoppingCartCheckout } from "react-icons/md";
// import { motion } from "framer-motion";
// import { FaArrowLeft } from "react-icons/fa";
// import { LiaOpencart } from "react-icons/lia";
// import { AbsoluteCenter, Tooltip } from "@chakra-ui/react";
// import { clearCart as clearCartUtil } from "./utils/cartUtils";
// import { deleteCartItem } from "../../../redux/api/website/Addtocartapi";
// import { getShadeDetailById } from "../../../redux/api/admin/shadeApi";
// import { getProduct } from "../../../redux/reduxApi/admin/ProductReduxApi";
// import {
//   getContactByEmail,
//   getLeadByEmail,
//   convertLeadToClient,
// } from "../../../redux/api/website/CheckoutApi";
// import { getLeadList } from "../../../redux/reduxApi/admin/LeadReduxApi";
// import { getShadeNumberList } from "../../../redux/reduxApi/admin/ShadeReduxApi";
// import { getMultiFactorResolver } from "firebase/auth";
// import { getMotorsList } from "../../../redux/reduxApi/admin/MotorizationReduxApi";
// import Heading from "../utils/Heading";

// const Cart = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const userId = localStorage.getItem("UserRowId");
//   const cart = useSelector((state) => {
//     if (state.CartProducts?.data && Array.isArray(state.CartProducts.data)) {
//       return state.CartProducts.data;
//     }

//     // Fallback to Cart slice if needed
//     if (
//       state.Cart?.CartProducts?.data &&
//       Array.isArray(state.Cart.CartProducts.data)
//     ) {
//       return state.Cart.CartProducts.data;
//     }

//     return [];
//   });

//   const cartLoading = useSelector(
//     (state) => state.CartProducts?.loading || false,
//   );
//   useEffect(() => {
//     const fetchUserCart = async () => {
//       try {
//         if (userId) {
//           const resp = await dispatch(getCartProductsWebuser());
//         } else {
//           // Handle guest cart
//           setLoading(true);
//           const guestCart = JSON.parse(localStorage.getItem("guestCart")) || [];
//           setCartData(guestCart);
//           setLoading(false);
//         }
//       } catch (error) {
//         console.error("Error fetching cart:", error);
//         toast.error("Failed to load cart");
//       }
//     };

//     fetchUserCart();
//   }, [dispatch, userId]);

//   const [cartData, setCartData] = useState([]);
//   const [guestProducts, setGuestProducts] = useState([]);
//   const [quantities, setQuantities] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [shadeId, setShadeId] = useState(null);
//   let guestId = Cookies.get("guest_id");
//   const [shadeDetails, setShadeDetails] = useState({}); // Store shade details
//   const [shadeLoading, setShadeLoading] = useState(false);
//   const [shadesData, setShadesData] = useState([]);
//   const getShadeNumberData = useSelector((state) => state?.shade?.shade);
//   // Get Shades data
//   useEffect(() => {
//     dispatch(getShadeNumberList())
//       .then((response) => {
//         const data = response.payload?.data?.shades || [];
//         setShadesData(data);
//         console.log("Shades Data-->", data);
//       })
//       .catch((error) => {
//         setLoading(false);
//         console.error("Error fetching Shades data:", error);
//         toast.error("Failed to load shades data");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [dispatch]);

//   // Sync with Redux state
//   useEffect(() => {
//     if (getShadeNumberData && getShadeNumberData.length > 0) {
//       setShadesData(getShadeNumberData);
//     }
//   }, [getShadeNumberData]);

//   // Function to get image URL based on shade number
//   const getShadeImageByShadeNo = (shadeNo) => {
//     if (!shadesData || shadesData.length === 0 || !shadeNo) {
//       return "/fallback-image.jpg";
//     }

//     // Find the shade with matching shadeNo
//     const shade = shadesData.find((item) => item.shadeNo === shadeNo);

//     if (shade && shade.shadeMedia && shade.shadeMedia.length > 0) {
//       return shade.shadeMedia[0];
//     }

//     return "/fallback-image.jpg";
//   };

//   // Area calculation functions (same as ProductDetailPage)
//   const inchesToSqFt = (widthInch, dropInch) => {
//     return (widthInch * dropInch) / 144;
//   };

//   const mmToSqFt = (widthMm, dropMm) => {
//     if (dropMm === 0) {
//       return 0;
//     }
//     const effectiveDrop = dropMm < 1000 ? 1000 : dropMm;
//     const initialValue = widthMm * effectiveDrop * 0.000001;
//     const adjustedValue = initialValue < 1 ? 1 : initialValue;
//     const finalValue = adjustedValue * 10.764;
//     return finalValue;
//   };

//   const cmToSqFt = (widthCm, dropCm) => {
//     if (dropCm === 0) {
//       return 0;
//     }
//     const effectiveDrop = dropCm < 100 ? 100 : dropCm;
//     const initialValue = widthCm * effectiveDrop * 0.0001;
//     const adjustedValue = initialValue < 1 ? 1 : initialValue;
//     const finalValue = adjustedValue * 10.764;
//     return finalValue;
//   };

//   const calculateArea = (heightValue, widthValue, unit) => {
//     const h = Number(heightValue) || 0;
//     const w = Number(widthValue) || 0;

//     if (h <= 0 || w <= 0) {
//       console.log("Invalid dimensions - returning 0");
//       return 0;
//     }

//     let calculatedArea = 0;

//     switch (unit) {
//       case "inch":
//         calculatedArea = inchesToSqFt(w, h);
//         break;
//       case "mm":
//         calculatedArea = mmToSqFt(w, h);
//         break;
//       case "cm":
//         calculatedArea = cmToSqFt(w, h);
//         break;
//       default:
//         calculatedArea = 0;
//     }

//     return calculatedArea;
//   };

//   const calculateAmount = (area, qty, rate, taxRate) => {
//     const a = Number(area) || 0;
//     const q = Number(qty) || 0;
//     const r = Number(rate) || 0;
//     const t = Number(taxRate) || 0;

//     console.log("Calculating amount with:", {
//       area: a,
//       qty: q,
//       rate: r,
//       taxRate: t,
//     });

//     // Amount = Area × Quantity × Rate
//     const subtotal = a * q * r;
//     const taxAmount = (subtotal * t) / 100;

//     const result = {
//       subtotal,
//       taxAmount,
//       total: Number((subtotal + taxAmount).toFixed(2)),
//     };

//     console.log("Amount calculation result:", result);
//     return result;
//   };

//   // Calculate price for each product
//   const calculateProductPrice = (product) => {
//     console.log("Calculating price for product:", product);

//     // First, check if area exists in product data
//     let area = product?.area;

//     // If area doesn't exist in product, calculate it
//     if (!area || area === 0) {
//       area = calculateArea(
//         product?.height,
//         product?.width,
//         product?.measurements,
//       );
//       console.log(
//         "Calculated area for product:",
//         product?.productId,
//         "=",
//         area,
//       );
//     }

//     const qty = quantities[product?.ROWID] || product?.quantity || 1;
//     const rate =
//       parseFloat(product?.sellingPrice) || parseFloat(product?.price) || 0;
//     const taxRate =
//       parseFloat(product?.taxRate) || parseFloat(product?.tax) || 0;

//     return calculateAmount(area, qty, rate, taxRate);
//   };

//   // Memoized calculations for each product
//   const productCalculations = useMemo(() => {
//     const calculations = {};
//     cart.forEach((product) => {
//       calculations[product.ROWID] = calculateProductPrice(product);
//     });
//     return calculations;
//   }, [cart, quantities]);

//   // Calculate subtotal based on area-based pricing
//   const subtotal = useMemo(() => {
//     const total = cart.reduce((acc, product) => {
//       const calc = productCalculations[product.ROWID];
//       const productSubtotal = calc?.subtotal || 0;
//       return acc + productSubtotal;
//     }, 0);

//     return total.toFixed(2);
//   }, [cart, productCalculations]);

//   const shippingRate = 0.18;
//   const shippingCost = (parseFloat(subtotal) * shippingRate).toFixed(2);
//   const total = (parseFloat(subtotal) + parseFloat(shippingCost)).toFixed(2);

//   // Debug: Log when quantities change
//   useEffect(() => {
//     console.log("Quantities updated:", quantities);
//   }, [quantities]);

//   // Debug: Log when cart changes
//   useEffect(() => {
//     console.log("Cart updated:", cart);
//   }, [cart]);

//   useEffect(() => {
//     const fetchUserCart = async () => {
//       try {
//         setLoading(true);
//         const resp = await dispatch(getCartProductsWebuser());
//         setLoading(false);
//       } catch (error) {
//         setLoading(false);
//         console.error("Error fetching guest cart:", error);
//       }
//     };

//     fetchUserCart();
//   }, [dispatch, userId]);

//   useEffect(() => {
//     const initialQuantities = {};
//     cart?.forEach((product) => {
//       // Ensure quantity is stored as a number, not string
//       initialQuantities[product.ROWID] = Number(product?.quantity) || 1;
//     });
//     setQuantities(initialQuantities);
//     setCartData(cart);
//   }, [cart]);

//   const getInventory = useSelector((state) => state?.inventory?.inventory);

//   useEffect(() => {
//     const fetchAllProducts = async () => {
//       try {
//         await dispatch(getProduct({ page: 1, limit: 300 }));
//       } catch (error) {
//         console.error("Error fetching products:", error);
//       }
//     };
//     fetchAllProducts();
//   }, [dispatch]);

//   const [cartIInventorytems, setCartItems] = useState([]);

//   const getItemNameByProductId = (productId) => {
//     if (!Array.isArray(getInventory)) return "N/A";
//     const matched = getInventory.find((inv) => inv.ROWID === productId);
//     return matched?.itemName || "N/A";
//   };

//   useEffect(() => {
//     const fetchShadeDetails = async () => {
//       if (cart.length === 0) return;

//       try {
//         setShadeLoading(true);
//         const shadePromises = cart.map(async (product) => {
//           try {
//             if (product?.productId) {
//               // Pass productId to getShadeDetailById
//               const shadeData = await getShadeDetailById(product.productId);
//               console.log(
//                 "Shade details for product:",
//                 product.productId,
//                 shadeData,
//               );

//               // Extract image and shade name from response
//               const shadeImage =
//                 shadeData?.image ||
//                 shadeData?.images?.[0]?.url ||
//                 shadeData?.productImage ||
//                 "/fallback-image.jpg";

//               const shadeName =
//                 shadeData?.shadeName ||
//                 shadeData?.name ||
//                 shadeData?.shadeNo ||
//                 "Unknown Shade";

//               return {
//                 productId: product.productId,
//                 shadeImage,
//                 shadeName,
//                 // Other shade details you might need
//                 mechanismColor:
//                   shadeData?.mechanismColor || product?.mechanismColor || "N/A",
//                 fabricType: shadeData?.fabricType || "N/A",
//               };
//             }
//             return null;
//           } catch (error) {
//             console.error(
//               `Error fetching shade details for ₹{product.productId}:`,
//               error,
//             );
//             return {
//               productId: product.productId,
//               shadeImage: "/fallback-image.jpg",
//               shadeName: "Error loading",
//               mechanismColor: product?.mechanismColor || "N/A",
//               fabricType: "N/A",
//             };
//           }
//         });

//         const shadeResults = await Promise.all(shadePromises);

//         // Convert to object for easy lookup
//         const shadeMap = {};
//         shadeResults.forEach((result) => {
//           if (result) {
//             shadeMap[result.productId] = result;
//           }
//         });

//         setShadeDetails(shadeMap);
//         setShadeLoading(false);
//       } catch (error) {
//         console.error("Error fetching shade details:", error);
//         setShadeLoading(false);
//       }
//     };

//     fetchShadeDetails();
//   }, [cart]);

//   const increaseQuantity = async (productId) => {
//     setQuantities((prev) => {
//       const currentValue = prev[productId];
//       // Parse the current value as a number, default to 1 if not found
//       const currentQty = parseInt(currentValue) || 1;
//       return {
//         ...prev,
//         [productId]: currentQty + 1,
//       };
//     });
//   };

//   const decreaseQuantity = async (productId) => {
//     setQuantities((prev) => {
//       const currentValue = prev[productId];
//       // Parse the current value as a number, default to 1 if not found
//       const currentQty = parseInt(currentValue) || 1;
//       return {
//         ...prev,
//         [productId]: Math.max(1, currentQty - 1),
//       };
//     });
//   };

//   const handleRemove = async (ROWID) => {
//     try {
//       const response = await dispatch(deleteCartItemThunk(ROWID));
//       if (response.payload?.success && response.payload?.deletedRows > 0) {
//         toast.success("Item removed from cart");
//         dispatch(getCartProductsWebuser());
//       } else {
//         toast.error(response.payload?.message || "Failed to remove item");
//       }
//     } catch (error) {
//       console.error("❌ Error in handleRemove:", error);
//       toast.error("Something went wrong");
//     }
//   };

//   const clearCart = async () => {
//     try {
//       if (!cart || cart.length === 0) {
//         toast.info("Cart is already empty");
//         return;
//       }
//       const rowIds = cart.map((item) => item.ROWID);
//       const response = await dispatch(clearCartApi(rowIds));
//       if (response.payload) {
//         toast.success("Cart cleared successfully");
//         dispatch(getCartProductsWebuser()); // refresh cart
//       } else {
//         toast.error("Failed to clear cart");
//       }
//     } catch (error) {
//       console.error("❌ Error in clearCart:", error);
//       toast.error("Something went wrong");
//     }
//   };

//   const [checkoutLoading, setCheckoutLoading] = useState(false);
//   const handleCheckout = async () => {
//     const userId = localStorage.getItem("UserRowId");
//     const userEmail = localStorage.getItem("userEmail");
//     if (!userId || !userEmail) {
//       localStorage.setItem("redirect", location.pathname);
//       navigate("/login");
//       return;
//     }

//     try {
//       setCheckoutLoading(true);

//       // STEP 1: First check Lead by email using thunk
//       console.log("STEP 1: Checking lead by email:", userEmail);
//       let leadId = null;

//       try {
//         // Using the thunk for getLeadByEmail
//         const leadAction = await dispatch(getLeadByEmail(userEmail));
//         console.log("Lead action result:", leadAction);

//         const leadRes = leadAction.payload;

//         if (leadRes?.success && leadRes?.data) {
//           leadId = leadRes.data.ROWID;
//           console.log("✅ Lead found with ID:", leadId);

//           // STEP 2: Convert lead to client
//           console.log("STEP 2: Converting lead to client with ID:", leadId);
//           const convertAction = await dispatch(convertLeadToClient(leadId));
//           const convertRes = convertAction.payload;
//           if (convertRes?.success) {
//             console.log("✅ Lead converted successfully.");

//             const clientId =
//               convertRes.data?.clientId ||
//               convertRes.data?.ROWID ||
//               convertRes.data?.id ||
//               leadId;

//             console.log("Client ID for checkout:", clientId);

//             navigate("/shop/checkouts", {
//               state: {
//                 clientId: clientId,
//                 cartItems: cart,
//                 subtotal,
//                 shippingCost,
//                 total,
//               },
//             });
//             return;
//           } else {
//             console.error("❌ Failed to convert lead:", convertRes);
//             toast.error(
//               convertRes?.message || "Failed to convert lead to client",
//             );
//             return;
//           }
//         }
//       } catch (leadError) {
//         console.log("Lead check failed:", leadError);
//       }

//       // STEP 3: If no lead found, check Contact by email (using regular function)
//       console.log(
//         "STEP 3: No lead found, checking contact by email:",
//         userEmail,
//       );
//       try {
//         const contactResponse = await getContactByEmail(userEmail);
//         if (contactResponse?.success && contactResponse?.data) {
//           const contactId = contactResponse.data.ROWID;
//           navigate("/shop/checkouts", {
//             state: {
//               clientId: contactId,
//               cartItems: cart,
//               subtotal,
//               shippingCost,
//               total,
//             },
//           });
//           return;
//         }
//       } catch (contactError) {
//         console.log("Contact check failed:", contactError);
//       }

//       // STEP 4: If neither lead nor contact found
//       console.error("❌ No lead or contact found for email:", userEmail);
//       toast.error("No user found with this email. Please register first.");
//     } catch (err) {
//       console.error("❌ Checkout error:", err);

//       let errorMessage = "Checkout failed. Please try again.";
//       if (err.response?.data?.message) {
//         errorMessage = err.response.data.message;
//       }

//       toast.error(errorMessage);
//     } finally {
//       setCheckoutLoading(false);
//     }
//   };

//   const [motorData, setMotorData] = useState([]);
//   const [searchQuery, setSearchQuery] = useState(null);
//   useEffect(() => {
//     const payload = searchQuery;
//     dispatch(getMotorsList(payload))
//       .then((res) => {
//         const list = res?.payload?.data?.motors || [];
//         setMotorData(list);
//       })
//       .catch((err) => {
//         console.error("Error fetching motors:", err);
//         toast.error("Failed to fetch motors");
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [dispatch]);

//   const getMotorNameById = (motorRowId) => {
//     if (
//       !motorRowId ||
//       motorRowId === "N/A" ||
//       !motorData ||
//       motorData.length === 0
//     ) {
//       return "N/A";
//     }

//     const motor = motorData.find((m) => m.ROWID === motorRowId);
//     return motor?.motorName || motorRowId || "N/A";
//   };
//   return (
//     <div className="">
//       {loading ? (
//         <div className="relative w-full h-[300px]">
//           <Shoploader />
//         </div>
//       ) : (
//         cart?.length == 0 ? (
//           /* Empty Cart State */
//           <div className="w-full mx-auto text-center py-16 px-4">
//             <div className="max-w-md mx-auto">
//               <motion.div
//                 animate={{
//                   y: [0, -20, 0],
//                   rotate: [0, 5, -5, 0]
//                 }}
//                 transition={{
//                   duration: 4,
//                   repeat: Infinity,
//                   repeatType: "reverse"
//                 }}
//               >
//                 <LiaOpencart className="text-8xl text-[#66944b] mx-auto" />
//               </motion.div>

//               <h2 className="text-3xl font-semibold text-[#661E33] mb-3">Your Cart is Empty</h2>
//               <p className="text-gray-500 text-base mb-8 max-w-md mx-auto">
//                 Looks like you haven't added anything yet. Explore our collection and find something special!
//               </p>

//               <Link to="/shop">
//                 <button className="px-6 py-3 bg-[#66944b] hover:bg-[#5a8240] text-white rounded-lg font-medium transition-colors shadow-sm hover:shadow">
//                   Continue Shopping
//                 </button>
//               </Link>
//             </div>
//           </div>
//         ) : (
//           <>
//             <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 items-start container">
//               <div className="lg:col-span-9 flex flex-col gap-6 mt-2">
//                 <div className="w-full">
//                   <div class="flex flex-col">
//                     <h1 className={` text-2xl text-[#661e33] font-playfair mb-0 `}>Your Custom Order</h1>
//                     <p class="text-slate-600 dark:text-slate-400 mb-0">Review your customized selections before checkout.</p>
//                   </div>

//                   <div className="border rounded pb-2">
//                     {/* Header Row - Desktop Only */}
//                     <div className="hidden md:grid grid-cols-12 gap-4 p-3 bg-gradient-to-r from-[#66944b] to-[#7fb073] rounded-t-lg  text-sm font-semibold text-white uppercase tracking-wider mb-2">
//                       <div className="col-span-8">Product Details</div>
//                       {/* <div className="col-span-2 text-center">Quantity</div> */}
//                       <div className="col-span-2 text-right">Unit Price</div>
//                       <div className="col-span-2 text-right">Total</div>
//                     </div>

//                     {/* Cart Items */}
//                     <div className="flex flex-col gap-4 px-3 py-1">
//                       {cart?.map((product) => {
//                         const calc = productCalculations[product.ROWID] || {
//                           subtotal: 0,
//                           taxAmount: 0,
//                           total: 0,
//                         };
//                         const area = product?.area || calculateArea(
//                           product.height,
//                           product.width,
//                           product.measurements,
//                         );
//                         const imageUrl = getShadeImageByShadeNo(product?.shadeNo);

//                         return (
//                           <div key={product?.ROWID} className="group bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-shadow p-2 md:p-4">
//                             <div className="grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-6 items-start">
//                               {/* Product Image & Info - Takes full width on mobile, 8 cols on desktop */}
//                               <div className="md:col-span-8 flex flex-col sm:flex-row gap-4">
//                                 <div className="w-24 h-24 shrink-0 rounded-lg overflow-hidden bg-gray-100 border border-gray-200 relative mx-auto sm:mx-0">
//                                   <img
//                                     src={imageUrl}
//                                     alt={product?.shadeNo || "Product image"}
//                                     className="w-full h-full object-cover"
//                                     onError={(e) => {
//                                       e.target.src = "/fallback-image.jpg";
//                                     }}
//                                   />
//                                 </div>

//                                 <div className="flex-1">
//                                   <div className="flex justify-between items-start md:block">
//                                     <h3 className="font-bold text-gray-800 text-lg">Shade {product?.shadeNo}</h3>
//                                     <span className="md:hidden font-bold text-[#66944b] text-lg">
//                                       ₹{product?.total || "0"}
//                                     </span>
//                                   </div>

//                                   <div className="text-sm text-gray-500 space-y-1 mt-2">
//                                     <p className="flex items-start gap-2 mb-0">
//                                       <span className="w-32 font-medium text-gray-600 shrink-0">Dimensions</span>
//                                       <span>{product?.width || "0"} {product?.measurements} x {product?.height || "0"} {product?.measurements}</span>
//                                     </p>

//                                     <p className="flex items-start gap-2">
//                                       <span className="w-32 font-medium text-gray-600 shrink-0">Mechanism Type:</span>
//                                       <span>{getItemNameByProductId(product.productId)}</span>
//                                     </p>
//                                     <p className="flex items-start gap-2">
//                                       <span className="w-32 font-medium text-gray-600 shrink-0">Color:</span>
//                                       <span className="capitalize">{product?.mechanismColor || "N/A"}</span>
//                                     </p>
//                                     <p className="flex items-start gap-2">
//                                       <span className="w-32 font-medium text-gray-600 shrink-0">Motor:</span>
//                                       <span>{product?.motorization === "Yes" ? getMotorNameById(product?.motorType) : "No"}</span>
//                                     </p>
//                                     <p className="flex items-start gap-2">
//                                       <span className="w-32 font-medium text-gray-600 shrink-0">Side of Control:</span>
//                                       <span>{product?.sideOfControl || "N/A"}</span>
//                                     </p>
//                                     {product?.remarks && (
//                                       <p className="flex items-start gap-2">
//                                         <span className="w-32 font-medium text-gray-600 shrink-0">Remark:</span>
//                                         <span className="text-gray-500 italic border w-full p-1 rounded ">
//                                           {product?.remarks.length > 50
//                                             ? `${product.remarks.substring(0, 50)}...`
//                                             : product.remarks}
//                                         </span>
//                                       </p>
//                                     )}
//                                   </div>
//                                 </div>
//                               </div>

//                               {/* Price & Total Section - 4 cols on desktop, full width on mobile */}
//                               <div className="md:col-span-4 flex flex-col space-y-4">
//                                 {/* Price and Total in one row on desktop, stacked on mobile */}
//                                 <div className="flex flex-row md:flex-col justify-between items-center md:items-end gap-4 h-20">
//                                   {/* Unit Price */}
//                                   <div className="text-left md:text-right w-full">
//                                     <span className="text-xs text-gray-500 block md:hidden">Unit Price</span>
//                                     <span className="text-gray-600 text-sm md:text-base font-medium">
//                                       ₹{(parseFloat(product?.sellingPrice) || 0).toFixed(2)}
//                                     </span>
//                                   </div>

//                                   {/* Total Price */}
//                                   <div className="text-right w-full">
//                                     <span className="text-xs text-gray-500 block md:hidden">Total</span>
//                                     <span className="font-bold text-[#66944b] text-lg md:text-xl">
//                                       ₹{product?.total || "0"}
//                                     </span>
//                                     {/* {calc.subtotal > 0 && calc.taxAmount > 0 && (
//                                     <div className="text-xs text-gray-500 mt-1">
//                                       + ₹{calc.taxAmount.toFixed(2)} tax
//                                     </div>
//                                   )} */}
//                                   </div>
//                                 </div>

//                                 {/* Quantity Control - Below price and total */}
//                                 <div className="flex flex-row items-center  justify-end lg:justify-center gap-3 h-24">
//                                   <div className="flex items-center border border-gray-300 rounded-lg overflow-hidden bg-background-light">
//                                     <button
//                                       className="px-3 py-1.5 hover:bg-[#dfe9da] rounded-l-lg transition-colors"
//                                       onClick={() => decreaseQuantity(product?.ROWID)}
//                                     >
//                                       -
//                                     </button>
//                                     <input
//                                       className="w-12 text-center border-none bg-transparent focus:ring-0 font-bold text-sm"
//                                       readOnly
//                                       type="number"
//                                       value={quantities[product?.ROWID]}
//                                       onChange={(e) => {
//                                         const value = e.target.value;
//                                         const parsedValue = parseInt(value) || 1;
//                                         setQuantities({
//                                           ...quantities,
//                                           [product?.ROWID]: Math.max(1, parsedValue),
//                                         });
//                                       }}
//                                     />
//                                     <button
//                                       className="px-3 py-1.5 hover:bg-[#dfe9da] rounded-r-lg transition-colors "
//                                       onClick={() => increaseQuantity(product?.ROWID)}
//                                     >
//                                       +
//                                     </button>
//                                   </div>
//                                   <div className="h-5 w-px bg-gray-300" />
//                                   {/* Action Buttons */}
//                                   <div className="flex justify-center gap-3">
//                                     <button className="text-xs font-medium  hover:underline flex items-center gap-1 transition-colors">
//                                       <SquarePen size={20} />
//                                     </button>
//                                     <button
//                                       onClick={() => handleRemove(product?.ROWID)}
//                                       className="text-xs font-medium text-red-500 hover:text-red-600 hover:underline flex items-center gap-1 transition-colors"
//                                     >
//                                       <Trash2 size={20} />
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                             </div>
//                           </div>
//                         );
//                       })}
//                     </div>
//                   </div>
//                 </div>
//                 {cart?.length > 0 && (
//                   <div className="flex justify-between mb-2">
//                     <Button
//                       text="Clear Cart"
//                       onClick={() => {
//                         clearCart();
//                       }}

//                     />

//                   </div>
//                 )}
//               </div>

//               {/* Summary Section */}
//               <div className="lg:col-span-3  mt-16 border shadow rounded-md p-3 ">
//                 <h2 className="text-2xl font-bold mb-4 text-center border-b pb-1">
//                   Order Summary
//                 </h2>
//                 <div className="flex justify-between text-md ">
//                   <p>Subtotal:</p>
//                   <p className="font-bold">₹{subtotal}</p>
//                 </div>
//                 <div className="flex justify-between text-md ">
//                   <p>Shipping:</p>
//                   <p className="font-bold">₹{shippingCost}</p>
//                 </div>

//                 <div className="flex justify-between text-md ">
//                   <p>Total:</p>
//                   <p className="font-bold">₹{total}</p>
//                 </div>
//                 <button
//                   onClick={handleCheckout}
//                   disabled={checkoutLoading}
//                   className={`w-full bg-[#661e33] text-[#f6f6f6] hover:bg-[#ffffff] hover:text-[#66944b] border-2 border-[#661e33] hover:border-[#66944b] shadow-lg px-6 py-2 rounded mb-2 ₹{
//     checkoutLoading ? 'opacity-50 cursor-not-allowed' : ''
//   }`}
//                 >
//                   {checkoutLoading ? (
//                     <div className="flex items-center justify-center">
//                       <div className="w-5 h-5 border-t-2 border-white rounded-full animate-spin mr-2"></div>
//                       Processing...
//                     </div>
//                   ) : (
//                     "Proceed to Checkout"
//                   )}
//                 </button>
//                 <Link to="/shop">
//                   <button className="w-full bg-[#661e33] text-[#f6f6f6] hover:bg-[#ffffff] hover:text-[#66944b] border-2 border-[#661e33] hover:border-[#66944b] shadow-lg px-6 py-2 rounded">
//                     Continue Shopping
//                   </button>
//                 </Link>
//               </div>

//             </div>
//           </>
//         )

//       )}
//       {/* Mobile View */}
//       {cart?.length > 0 ? (
//         <div className="flex-1 p-2 rounded-lg border border-gray-200 d-block d-sm-none mb-2">
//           {cart.map((product) => {
//             const calc = productCalculations[product.ROWID] || {
//               subtotal: 0,
//               taxAmount: 0,
//               total: 0,
//             };
//             const area =
//               product?.area ||
//               calculateArea(
//                 product.height,
//                 product.width,
//                 product.measurements,
//               );

//             // Get image URL based on shadeNo for mobile view
//             const imageUrl = getShadeImageByShadeNo(product?.shadeNo);

//             return (
//               <div
//                 className="flex items-center p-2 rounded-lg border-b border-gray-200"
//                 key={product.productId}
//               >
//                 <div className="w-16 h-16 mr-3">
//                   <img
//                     src={imageUrl}
//                     alt={product?.shadeNo}
//                     className="w-full h-full object-cover"
//                     onError={(e) => {
//                       e.target.src = "/fallback-image.jpg";
//                     }}
//                   />
//                 </div>
//                 <div className="py-2 px-3 flex-1">
//                   <div className="text-xl py-1 font-bold">
//                     {product?.shadeNo}
//                   </div>
//                   {area > 0 && (
//                     <div className="text-sm text-gray-600 py-1">
//                       Area: {area.toFixed(2)} sq m
//                     </div>
//                   )}
//                   <div className="py-1 font-bold">
//                     ₹{calc.total.toFixed(2)}
//                   </div>
//                   <div className="flex gap-2">
//                     <button
//                       onClick={() => decreaseQuantity(product.productId)}
//                       className="bg-gray-300 px-3 rounded font-bold"
//                     >
//                       -
//                     </button>
//                     <input
//                       type="number"
//                       value={quantities[product.productId]}
//                       min="1"
//                       onChange={(e) =>
//                         setQuantities({
//                           ...quantities,
//                           [product.productId]: Math.max(
//                             1,
//                             parseInt(e.target.value) || 1,
//                           ),
//                         })
//                       }
//                       className="w-16 border border-gray-300 p-1 text-center font-bold"
//                     />
//                     <button
//                       onClick={() => increaseQuantity(product.productId)}
//                       className="bg-gray-300 px-3 rounded font-bold"
//                     >
//                       +
//                     </button>
//                   </div>
//                   <div className="my-2 flex">
//                     <button
//                       onClick={() => handleRemove(product?.ROWID)}
//                       className="text-white rounded font-bold"
//                     >
//                       <Trash2 color="#F97316" size="25px" strokeWidth="1" />
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             );
//           })}
//         </div>
//       ) : (
//         <div className="max-w-7xl mx-auto text-center py-20 px-4 hidden">
//           <div className="max-w-md mx-auto">

//             <div className="relative">
//               <motion.div
//                 animate={{
//                   y: [0, -20, 0],
//                   rotate: [0, 5, -5, 0]
//                 }}
//                 transition={{
//                   duration: 4,
//                   repeat: Infinity,
//                   repeatType: "reverse"
//                 }}
//               >
//                 <LiaOpencart className="text-9xl text-[#66944b] mx-auto" />
//               </motion.div>

//               <h2 className="text-4xl font-semibold text-[#661E33] mb-4">Your Cart is Empty</h2>
//               <p className="text-gray-500 text-lg mb-10 max-w-md mx-auto">
//                 Looks like you haven't added anything yet. Explore our collection and find something special!
//               </p>

//             </div>

//             <Link to="/shop">
//               <button className="px-4 py-2 bg-[#66944b] hover:bg-[#5a8240] text-white rounded-lg font-medium transition-colors shadow-sm hover:shadow">
//                 Continue Shopping
//               </button>
//             </Link>
//           </div>
//         </div>
//       )}
//     </div>
//   )
// }

// export default Cart;